import { Alert, Box, Button, Checkbox, Dialog, DialogContent, DialogContentText, DialogTitle, FormControl, FormControlLabel, FormGroup, FormHelperText, Grid, InputBase, InputLabel, MenuItem, Radio, RadioGroup, Select, Stack, TextField, Typography, useMediaQuery } from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react'
import { Controller, useForm, useFormContext, useWatch } from 'react-hook-form';
import { AmlQiVerificationList, checkboxColorSx, countryList, employmentAddressOption, employmentDataArray, genderOption, holderMaterialsOptions, initialInvestmentArray, originOfContactList, provinceList, radioColorSx, radioOptionArray, relationshipList } from 'store/constant';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import { faPlus } from '@fortawesome/free-solid-svg-icons'
// import FileItem from 'views/common-components/FileItem/FileItem';
// import { faFileAlt, faSpinner, faTrash, faDownload } from '@fortawesome/free-solid-svg-icons'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import axiosInstance from 'custom-axios';
import { useParams } from 'react-router';
import { useFullPageLoader } from 'hooks/useFullPageLoader';
import { styled } from '@mui/material/styles';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import 'views/common-components/FileUpload/FileUpload.css';
import { IconButton } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import DeleteIcon from "@mui/icons-material/Delete";
import { showConfirmSweetAlert } from 'hooks/useSweetAlert';


// import axios from 'axios';

// const VisuallyHiddenInput = styled('input')({
//     clip: 'rect(0 0 0 0)',
//     clipPath: 'inset(50%)',
//     height: 1,
//     overflow: 'hidden',
//     position: 'absolute',
//     bottom: 0,
//     left: 0,
//     whiteSpace: 'nowrap',
//     width: 1,
// });


const contentTypes = {
    'pdf': 'application/pdf',
    'jpg': 'image/jpeg',
    'jpeg': 'image/jpeg',
    'png': 'image/png'
};

const RegulatoryInformation = ({ activeStep, setActiveStep, setActiveParentStep }) => {

    const { id } = useParams();
    let userGetId = localStorage.getItem('user_get_id')
    const userId = id ? id : userGetId;

    const [loader, showLoader, hideLoader] = useFullPageLoader();
    const matchesMD = useMediaQuery((theme) => theme.breakpoints.down('md'));
    const [files, setFiles] = useState({
        id_proof_file: '',
        driver_license_file: '',
        passport_file: '',
        other_file: '',
        void_cheque_file: '',
    });

    const [dialogOpen, setDialogOpen] = useState({
        tcp: false,
        pep_hio: false,
        insider: false
    });

    // const loginType = localStorage.getItem('login_type');
    const { register, control, watch, handleSubmit, setValue, getValues, formState: { errors } } = useFormContext();


    const regulatoryPowerOfAttorney = useWatch({
        control,
        name: 'regulatory_power_of_attorney',
        defaultValue: ''
    });

    const poaEmploymentStatus = useWatch({
        control,
        name: 'poa_employment_status',
        defaultValue: ''
    });

    const regulatoryTrustedContact = useWatch({
        control,
        name: 'regulatory_trusted_contact',
        defaultValue: ''
    });

    const isTaxResidentOther = useWatch({
        control,
        name: 'is_tax_resident_other',
        defaultValue: ''
    });

    const isTaxResidentCanada = useWatch({
        control,
        name: 'is_tax_resident_canada',
        defaultValue: ''
    });
    const isTaxResidentUsa = useWatch({
        control,
        name: 'is_tax_resident_usa',
        defaultValue: ''
    });

    const {
        poa_street_no: existingStreetNo = '',
        poa_street_name: existingStreetName = '',
        poa_unit_no: existingApartmentNo = '',
        poa_city: existingCity = '',
        poa_postal_code: existingPostalCode = '',
        poa_province: existingProvince = '',
        poa_country: existingCountry = '',
    } = getValues() || {};

    const personName = getValues('p_first_name') || '';
    const personLname = getValues('p_last_name') || '';

    const wStreetNo = watch('poa_emp_street_no');
    const wStreetName = watch('poa_emp_street_name');
    const wAptNo = watch('poa_emp_apartment_no');
    const wCity = watch('poa_emp_city');
    const wPostal = watch('poa_emp_postal_code');

    const handleDialogToggle = useCallback((dialogKey, isOpen) => {
        setDialogOpen((prev) => ({
            ...prev,
            [dialogKey]: isOpen,
        }));
    }, []);

    // dialog section------------
    const handleClickTcpOpen = useCallback(() => handleDialogToggle('tcp', true), [handleDialogToggle]);
    const handleTcpClose = useCallback(() => handleDialogToggle('tcp', false), [handleDialogToggle]);

    const handleClickPepOpen = useCallback(() => handleDialogToggle('pep_hio', true), [handleDialogToggle]);
    const handlePepClose = useCallback(() => handleDialogToggle('pep_hio', false), [handleDialogToggle]);

    const handleClickInsiderOpen = useCallback(() => handleDialogToggle('insider', true), [handleDialogToggle]);
    const handleInsiderClose = useCallback(() => handleDialogToggle('insider', false), [handleDialogToggle]);


    const OpenTcpDialogComponent = () => {
        return (
            <>
                <Dialog
                    fullScreen={matchesMD}
                    open={dialogOpen.tcp}
                    onClose={handleTcpClose}
                    aria-labelledby="responsive-dialog-title"
                    scroll='paper'
                >
                    <DialogTitle id="responsive-dialog-title">
                        Trusted Contact person
                    </DialogTitle>
                    <DialogContent dividers={true}>
                        <DialogContentText>
                            A trusted contact person (TCP) is someone other than your spouse whom your advisor and portfolio manager
                            could contact in the event you become mentally incapacitated and unable to make sound financial decisions.
                        </DialogContentText>
                    </DialogContent>
                </Dialog>
            </>
        )
    }

    const OpenPepHioDialogComponent = () => {
        return (
            <>
                <Dialog
                    fullScreen={matchesMD}
                    open={dialogOpen.pep_hio}
                    onClose={handlePepClose}
                    scroll='paper'
                    aria-labelledby="responsive-dialog-title"
                    sx={{ marginTop: '100px' }}
                >
                    <DialogTitle id="responsive-dialog-title">
                        Politically Exposed Persons (PEP) / Head of international Org (HIO)
                    </DialogTitle>
                    <DialogContent dividers={true}>
                        <DialogContentText>
                            <Typography paragraph>
                                A politically exposed person (“PEP”) is a person or family member of a person who has held one of the
                                following offices and/or positions in or on behalf of a foreign country or domestically. For the purposes
                                of this discussion, family members include a spouse or common-law partner, child, mother or father, mother
                                or father of a spouse or common-law partner, and sibling.
                            </Typography>

                            <Typography paragraph>
                                <strong>Foreign PEP:</strong> A person who holds or has held one of the following offices or positions in or on behalf
                                of a foreign state:
                            </Typography>
                            <ul>
                                <li>Head of state or head of government.</li>
                                <li>Member of the executive council of government or member of a legislature.</li>
                                <li>Deputy minister or equivalent rank.</li>
                                <li>Ambassador, or attaché or counsellor of an ambassador.</li>
                                <li>Military officer with a rank of general or above.</li>
                                <li>President of a state-owned company or a state-owned bank.</li>
                                <li>Head of a government agency.</li>
                                <li>Judge of a supreme court, constitutional court or other court of last resort.</li>
                                <li>Leader or president of a political party represented in a legislature.</li>
                            </ul>

                            <Typography paragraph>
                                <strong>Domestic PEP:</strong> A person who holds — or has held within the last five years — a specific office or position in
                                or on behalf of the Canadian federal government, a Canadian provincial government, or a Canadian municipal
                                government:
                            </Typography>
                            <ul>
                                <li>Governor General, lieutenant governor or head of government.</li>
                                <li>Member of the Senate, House of Commons, or legislature member.</li>
                                <li>Deputy minister or equivalent rank.</li>
                                <li>Ambassador, or attaché or counsellor of an ambassador.</li>
                                <li>Military officer with a rank of general or above.</li>
                                <li>President of a corporation wholly owned by Her Majesty in right of Canada or a province.</li>
                                <li>Head of a government agency.</li>
                                <li>Judge of an appellate court in a province, the Federal Court of Appeal or the Supreme Court of Canada.</li>
                                <li>Leader or president of a political party represented in a legislature.</li>
                                <li>Mayor.</li>
                            </ul>
                        </DialogContentText>
                    </DialogContent>
                </Dialog>
            </>
        )
    }

    const InsiderDialogComponent = () => {
        return (
            <>
                <Dialog
                    fullScreen={matchesMD}
                    open={dialogOpen.insider}
                    onClose={handleInsiderClose}
                    scroll='paper'
                    aria-labelledby="responsive-dialog-title"
                    sx={{ marginTop: '100px' }}
                >
                    <DialogTitle id="responsive-dialog-title" className='font12px'>
                        Insider
                    </DialogTitle>
                    <DialogContent dividers={true}>
                        <DialogContentText>

                            <Typography paragraph>
                                {/* <ul>
                                        <li><strong>Insider:</strong> </li>
                                    </ul> */}
                                <Typography paragraph>
                                    <strong className='color-545151'>Insider: </strong> You may be a "reporting insider" if you are a CEO, CFO or COO, a significant shareholder, or a director of the board of the reporting issuer whose shares trade on any Canadian exchange.
                                </Typography>
                            </Typography>

                            <Typography paragraph>
                                <strong className='color-545151'>Shareholder 10% & 20% : </strong>
                                Is there anyone in your household who, either individually or as part of a group, owns or controls 10% / 20% or more of the voting rights of a publicly traded company?
                            </Typography>

                            <Typography paragraph>
                                <strong className='color-545151'>CIRO : </strong>
                                CIRO Stands for Canadian Investment Regulatory Organization
                            </Typography>
                        </DialogContentText>
                    </DialogContent>
                </Dialog>
            </>
        )
    }

    const fetchUserRegulatoryFiles = async () => {

        try {
            const response = await axiosInstance.get(`api/get-user-regulatory-file/${userId}`);

            if (response.data) {
                setFiles(response.data);
            }

        } catch (error) {
            // console.error(error.message);
        }
    };


    const uploadHandler = async (e, type) => {

        const file = e.target.files[0];
        const maxSize = 2 * 1024 * 1024; // 2 MB in bytes

        const allowedTypes = ["application/pdf", "image/jpeg", "image/png"];

        if (!file) {
            toast.error("No file selected.");
            return;
        }

        if (!allowedTypes.includes(file.type)) {
            toast.error("Unsupported file type. Only PDF, JPEG, and PNG are allowed.");
            return;
        }

        if (file.size > maxSize) {
            toast.error("File size is too large. Maximum 2 MB allowed.");
            return;
        }

        let fileSize = file.size;
        const formFileData = new FormData();

        formFileData.append("file", file);
        formFileData.append("type", type);
        formFileData.append("user_id", userId);
        formFileData.append("file_size", fileSize);

        showLoader();
        const response = await axiosInstance.post(`api/upload-regulatory-file`, formFileData);

        if (response.success) {
            fetchUserRegulatoryFiles();
            // setFiles((prevFiles) => ({
            //     ...prevFiles,
            //     [type]: type, // Save only the file name
            // }));

            toast.success(response.message);
        } else {
            toast.error(response.message);
        }

        hideLoader();
    };

    const deleteHandler = async (_name, id) => {

        try {
            /*             let confirm = window.confirm("Are You Sure want to delete this file.")
            
                        if (confirm) { */
            const result = await showConfirmSweetAlert({
                title: 'Delete File?',
                text: 'Are you sure you want to delete?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, delete it!',
                cancelButtonText: 'No, cancel!',
            });

            if (result.isConfirmed) {

                showLoader()

                const data = { file_name: _name, user_id: userId, id: id }

                const response = await axiosInstance.post(`api/delete-regulatory-file`, data);

                if (response.success) {
                    toast.success(response.message);
                    fetchUserRegulatoryFiles()
                } else {
                    toast.error(response.message);
                }
            }

        } catch (error) {
            // toast.error(error.message)
            // console.error(error)
        } finally {
            hideLoader();
        }
    }

    const getFileExtension = (fileName) => {
        return fileName.split('.').pop().toLowerCase();
    };

    const downloadHandler = async (_name, id) => {

        try {
            const response = await axiosInstance.get(`api/download-regulatory-file/${id}/${userId}`, {
                responseType: 'blob',
                validateStatus: (status) => {
                    // console.log(status)
                    return status >= 200 && status < 500;
                },
            });

            const contentType = response['type'];

            if (contentType && contentType.includes('application/json')) {

                // Handle error response
                const reader = new FileReader();
                reader.onload = () => {
                    const errorResponse = JSON.parse(reader.result);
                    toast.error(errorResponse.error || 'An error occurred.');
                };
                reader.readAsText(response.data);
            } else {

                // Determine file extension and MIME type
                const extension = getFileExtension(_name);
                const mimeType = contentTypes[extension] || 'application/octet-stream';

                const url = window.URL.createObjectURL(new Blob([response], { type: mimeType }));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', _name);
                document.body.appendChild(link);
                link.click();
                link.remove();
            }

        } catch (error) {

            toast.error('An error occurred while downloading the file.');
            // console.error('Error downloading the file', error);

        } finally {
            hideLoader();
        }
    }

    const handleRoleBack = async () => {
        // setActiveStep(activeStep - 1);
        let endPoint = `api/change-form-step`;

        const submitData = { user_id: userId ? userId : 0, parent_step: 0, child_step: activeStep - 1 }

        try {
            const response = await axiosInstance.post(endPoint, submitData);

            if (response.status === 200) {
                setActiveStep(activeStep - 1);
            }

        } catch (error) {
            // console.error(error)
            toast.error('An error occurred when navigating back.')
        }
    };

    const submitPersonalInfo = async (data) => {

        let endPoint = `api/save-user-regulatory-info`;

        const submitData = { ...data, files: files, user_id: userId ? userId : 0, parent_step: 1, child_step: 0 }

        try {
            const response = await axiosInstance.post(endPoint, submitData);

            if (response.status === 200) {
                setActiveParentStep(1)
                setActiveStep(0);
            }

        } catch (error) {
            // console.error(error)
        }
    }

    useEffect(() => {
        fetchUserRegulatoryFiles();
    }, [])


    return (
        <>
            <form onSubmit={handleSubmit(submitPersonalInfo)}>
                <Grid container spacing={2} className='p-4'>

                    <Grid item xs={12}>
                        <Typography variant='h3' className='form-head-gray-title'>Power Of Attorney</Typography>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-right'}`}>
                        <label htmlFor="regulatory_power_of_attorney" className='font15px pr-10px'>Is there a power of attorney for {personName} {' '} {personLname}?</label>
                    </Grid>

                    <Grid item xs={12} sm={6} md={2}>
                        <FormControl component="fieldset" >
                            <Controller
                                name="regulatory_power_of_attorney"
                                control={control}
                                rules={{ required: "This field is required" }}
                                render={({ field }) => (
                                    <RadioGroup {...field} row aria-labelledby="regulatory_power_of_attorney" value={field.value || ''}>
                                        {radioOptionArray.map((option) => (
                                            <FormControlLabel
                                                key={option.value}
                                                value={option.value}
                                                control={<Radio sx={radioColorSx} />}
                                                label={option.label}
                                            />
                                        ))}
                                    </RadioGroup>
                                )}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}></Grid>
                    {regulatoryPowerOfAttorney == 1 &&
                        (
                            <>
                                <Grid item xs={3} className='text-right align-content-center pr-10px'>
                                    <label htmlFor="poa_first_name" className='font15px'>First Name</label>
                                </Grid>

                                <Grid item xs={6}>

                                    <TextField
                                        label="First Name"
                                        fullWidth
                                        size='small'
                                        {...register('poa_first_name', { required: true })}
                                        error={Boolean(errors?.poa_first_name)}
                                    />
                                </Grid>
                                <Grid item xs={3}></Grid>

                                <Grid item xs={3} className='text-right align-content-center pr-10px'>
                                    <label htmlFor="p-last-name" className='font15px'>Last Name</label>
                                </Grid>

                                <Grid item xs={6}>
                                    <TextField
                                        label="Last Name"
                                        fullWidth
                                        id='p-last-name'
                                        size='small'
                                        {...register('poa_last_name', { required: true })}
                                        error={Boolean(errors?.poa_last_name)}
                                    />
                                </Grid>
                                <Grid item xs={3}></Grid>



                                <Grid item xs={3} className='text-right align-content-center pr-10px'>
                                    <label htmlFor="p-middle-initial" className='font15px'>Middle Initial</label>
                                </Grid>

                                <Grid item xs={6}>
                                    <TextField
                                        label="Middle Initial"
                                        id='p-middle-initial'
                                        fullWidth
                                        size='small'
                                        {...register('poa_middle_name', { required: true })}
                                    />
                                </Grid>
                                <Grid item xs={3}></Grid>

                                <Grid item xs={3} className='text-right align-content-center pr-10px'>
                                    <label htmlFor="p-gender" className='font15px'>Gender</label>
                                </Grid>

                                <Grid item xs={3}>
                                    <FormControl component="fieldset" error={Boolean(errors?.poa_gender)}>
                                        <Controller
                                            name="poa_gender"
                                            control={control}
                                            rules={{ required: "Gender is required" }}
                                            render={({ field }) => (
                                                <RadioGroup {...field} row aria-labelledby="poa_gender" value={field.value || ''}>
                                                    {genderOption.map((option) => (
                                                        <FormControlLabel
                                                            key={option.value}
                                                            value={option.value}
                                                            control={<Radio sx={radioColorSx} />}
                                                            label={option.label}
                                                        />
                                                    ))}
                                                </RadioGroup>
                                            )}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={6}></Grid>


                                <Grid item xs={3} className='text-right align-content-center pr-10px'>
                                    <label htmlFor="p-citizenship-label" className='font15px'>Country</label>
                                </Grid>

                                <Grid item xs={3}>

                                    <FormControl sx={{ minWidth: 280 }} size="small" error={Boolean(errors?.poa_citizenship)}>
                                        <InputLabel id="p-citizenship-label">Country</InputLabel>
                                        <Controller
                                            name="poa_citizenship"
                                            control={control}
                                            rules={{ required: "Citizenship is required" }}
                                            render={({ field }) => (
                                                <Select
                                                    {...field}
                                                    value={field.value ?? ''}
                                                    labelId="p-citizenship-label"
                                                    id="p-citizenship-label"
                                                    label="Country"
                                                    MenuProps={{
                                                        disableScrollLock: true,
                                                        PaperProps: { sx: { maxHeight: 200 } }
                                                    }}
                                                >
                                                    {countryList?.map((row) => (
                                                        <MenuItem key={row.value} value={row.value}>{row.label}</MenuItem>
                                                    ))}
                                                </Select>
                                            )}
                                        />
                                    </FormControl>
                                </Grid>

                                <Grid item xs={6}></Grid>

                                {/* ----------sin---------- */}
                                <Grid item xs={12} sm={3} md={3} className={`align-content-center ${matchesMD ? '' : 'text-right'}`}>
                                    <label htmlFor="is-tex-resident-canada" className='font15px pr-10px'>Social Insurance Number</label>
                                </Grid>

                                <Grid item xs={12} sm={6} md={6}>

                                    <TextField
                                        label="Social Insurance Number"
                                        fullWidth
                                        size="small"
                                        error={Boolean(errors?.poa_sin)}
                                        inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                                        {...register('poa_sin', { required: "Social Insurance Number is required" })}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={3} md={3}></Grid>

                                {/*--------------------- relationship to you ---------------- */}

                                <Grid item xs={3} className='text-right align-content-center pr-10px'>
                                    <label htmlFor="poa-relationship-to-you" className='font15px'>Relationship to you</label>
                                </Grid>

                                <Grid item xs={3}>
                                    <FormControl sx={{ minWidth: 280 }} size="small" error={Boolean(errors?.poa_relationship_to_you)}>
                                        <InputLabel id="poa_relationship_to_you">Relationship to you</InputLabel>
                                        <Controller
                                            name="poa_relationship_to_you"
                                            control={control}
                                            rules={{ required: "Relationship to you is required" }}
                                            render={({ field }) => (
                                                <Select
                                                    {...field}
                                                    value={field.value ?? ''}
                                                    labelId="poa_relationship_to_you"
                                                    id="poa-relationship-to-you"
                                                    label="Relationship to you"
                                                    MenuProps={{
                                                        disableScrollLock: true,
                                                        PaperProps: { sx: { maxHeight: 200 } }
                                                    }}
                                                >
                                                    {relationshipList?.map((row) => (
                                                        <MenuItem key={row.value} value={row.value}>{row.label}</MenuItem>
                                                    ))}
                                                </Select>
                                            )}
                                        />
                                    </FormControl>
                                </Grid>

                                <Grid item xs={6}></Grid>


                                <Grid item xs={12}>
                                    <Typography component={'h3'} className='form-head-gray-title' sx={{
                                        backgroundColor: "transparent",
                                        fontWeight: 600
                                    }}>Address
                                    </Typography>
                                </Grid>

                                <Grid item xs={6} className='pr-10px'>
                                    <TextField
                                        label="Street No"
                                        fullWidth
                                        size="small"
                                        {...register('poa_street_no', { required: true })}
                                        error={Boolean(errors?.poa_street_no)}
                                    />
                                </Grid>

                                <Grid item xs={6} className='pr-10px'>
                                    <TextField
                                        label="Street Name"
                                        fullWidth
                                        size="small"
                                        {...register('poa_street_name', { required: true })}
                                        error={Boolean(errors?.poa_street_name)}
                                    />
                                </Grid>

                                <Grid item xs={6} className='pr-10px'>
                                    <TextField
                                        label="Unit/Apt No"
                                        fullWidth
                                        size="small"
                                        {...register('poa_unit_no')}
                                    />
                                </Grid>


                                <Grid item xs={6} className='pr-10px'>
                                    <TextField
                                        label="City"
                                        fullWidth
                                        size="small"
                                        {...register('poa_city', { required: true })}
                                        error={Boolean(errors?.poa_city)}
                                    />
                                </Grid>

                                <Grid item xs={6} className='pr-10px'>

                                    <FormControl fullWidth size="small" error={Boolean(errors?.poa_province)}>
                                        <InputLabel id="select-poa-province">Province</InputLabel>
                                        <Controller
                                            name="poa_province"
                                            control={control}
                                            rules={{ required: "Province is required" }}
                                            render={({ field }) => (
                                                <Select
                                                    {...field}
                                                    value={field.value ?? ''}
                                                    labelId="select-poa-province"
                                                    label="Province"
                                                    MenuProps={{
                                                        disableScrollLock: true,
                                                        PaperProps: { sx: { maxHeight: 200 } }
                                                    }}
                                                >
                                                    {provinceList.map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
                                                    ))}
                                                </Select>
                                            )}
                                        />
                                    </FormControl>

                                </Grid>

                                <Grid item xs={6} className='pr-10px'>
                                    <FormControl fullWidth size="small" error={Boolean(errors?.poa_country)}>
                                        <InputLabel id="select-poa-country">Country</InputLabel>
                                        <Controller
                                            name="poa_country"
                                            control={control}
                                            rules={{ required: "Country is required" }}
                                            render={({ field }) => (
                                                <Select
                                                    {...field}
                                                    value={field.value ?? ''}
                                                    labelId="select-poa-country"
                                                    label="Country"
                                                    MenuProps={{
                                                        disableScrollLock: true,
                                                        PaperProps: { sx: { maxHeight: 200 } }
                                                    }}
                                                >
                                                    {countryList.map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                            {option.label}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            )}
                                        />
                                    </FormControl>

                                </Grid>

                                <Grid item xs={6} className='pr-10px'>
                                    <TextField
                                        label="Postal Code"
                                        fullWidth
                                        size="small"
                                        id="jt-postal-code"
                                        {...register('poa_postal_code', { required: true })}
                                        error={Boolean(errors?.poa_postal_code)}
                                    />
                                </Grid>

                                <Grid item xs={6} className='pr-10px'></Grid>

                                <Grid item xs={3} className='text-right align-content-center pr-10px'>
                                    <label htmlFor="poa_home_phone_no" className='font15px'>Home Phone Number</label>
                                </Grid>

                                <Grid item xs={6} className='pr-10px'>
                                    <TextField
                                        label="Home Phone Number"
                                        fullWidth
                                        size='small'
                                        {...register('poa_home_phone_no', { required: true })}
                                        error={Boolean(errors?.poa_home_phone_no)}
                                    />

                                </Grid>
                                <Grid item xs={3}></Grid>

                                <Grid item xs={3} className='text-right align-content-center pr-10px'>
                                    <label htmlFor="poa_cell_phone_no" className='font15px pr-10px'>Cell Phone Number</label>
                                </Grid>

                                <Grid item xs={6} className='pr-10px'>
                                    <TextField
                                        label="Cell Phone Number"
                                        fullWidth
                                        size='small'
                                        {...register('poa_cell_phone_no', { required: true })}
                                        error={Boolean(errors?.poa_cell_phone_no)}
                                    />
                                </Grid>
                                <Grid item xs={3}></Grid>

                                <Grid item xs={3} className='text-right align-content-center pr-10px'>
                                    <label htmlFor="poa_business_phone_no" className='font15px'>Business Phone Number</label>
                                </Grid>

                                <Grid item xs={6}>
                                    <TextField
                                        label="Business Phone Number"
                                        fullWidth
                                        size='small'
                                        {...register('poa_business_phone_no')}
                                    />

                                </Grid>
                                <Grid item xs={3}></Grid>

                                <Grid item xs={3} className='text-right align-content-center pr-10px'>
                                    <label htmlFor="poa_email" className='font15px'>Email</label>
                                </Grid>

                                <Grid item xs={6}>
                                    <TextField
                                        label="Email"
                                        fullWidth
                                        size='small'

                                        {...register('poa_email', { required: true })}
                                        error={Boolean(errors?.poa_email)}
                                    />

                                </Grid>
                                <Grid item xs={3}></Grid>

                                <Grid item xs={3} className='text-right align-content-center pr-10px'>
                                    <label htmlFor="poa-employment-status" className='font15px'>Employment Status</label>
                                </Grid>

                                <Grid item xs={3}>
                                    <FormControl sx={{ minWidth: 280 }} size="small" error={Boolean(errors?.poa_employment_status)}>
                                        <InputLabel id="poa-employment-status-label">Employment Status</InputLabel>
                                        <Controller
                                            name="poa_employment_status"
                                            control={control}
                                            rules={{ required: "Employment Status is required" }}
                                            render={({ field }) => (
                                                <Select
                                                    {...field}
                                                    value={field.value ?? ''}
                                                    labelId="poa-employment-status-label"
                                                    label="Employment Status"
                                                    MenuProps={{
                                                        disableScrollLock: true,
                                                        PaperProps: { sx: { maxHeight: 200 } }
                                                    }}
                                                >
                                                    {employmentDataArray.map((row) => (
                                                        <MenuItem key={row.value} value={row.value}>
                                                            {row.label}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            )}
                                        />
                                    </FormControl>

                                </Grid>
                                <Grid item xs={6}></Grid>

                                {poaEmploymentStatus === 1 || poaEmploymentStatus === 2 || poaEmploymentStatus === 3 ?
                                    <>
                                        <Grid item xs={3} className='text-right align-content-center pr-10px'>
                                            <label htmlFor="poa-emp-name" className='font15px'>Employer</label>
                                        </Grid>

                                        <Grid item xs={6}>
                                            <TextField
                                                label="Name Of Employer"
                                                fullWidth
                                                id='poa-emp-name'
                                                size='small'

                                                {...register('poa_emp_name', { required: true })}
                                                error={Boolean(errors?.poa_emp_name)}
                                            />
                                        </Grid>
                                        <Grid item xs={3}></Grid>
                                        {/* <Grid item xs={3}></Grid> */}


                                        {poaEmploymentStatus == 3 &&
                                            <>
                                                <Grid item xs={3} className='text-right align-content-center pr-10px'>
                                                    <label htmlFor="spousal_retirement_date" className='font15px'>Date of Retirement</label>
                                                </Grid>
                                                <Grid item xs={6}>

                                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                        <Stack spacing={3}>
                                                            <Controller
                                                                name="poa_emp_retirement_date"
                                                                control={control}
                                                                defaultValue={null}
                                                                render={({ field }) => (
                                                                    <DesktopDatePicker
                                                                        disableFuture
                                                                        label="Date Of Retirement"
                                                                        value={field.value || null}
                                                                        id="spousal_retirement_date"
                                                                        inputFormat="yyyy/MM/dd"
                                                                        onChange={(newValue) => field.onChange(newValue)}
                                                                        renderInput={(params) => (
                                                                            <TextField
                                                                                {...params}
                                                                                fullWidth
                                                                                size="small"
                                                                                error={Boolean(errors?.poa_emp_retirement_date)}
                                                                                helperText={errors?.poa_emp_retirement_date?.message}
                                                                            />
                                                                        )}
                                                                    />
                                                                )}
                                                            />
                                                        </Stack>
                                                    </LocalizationProvider>


                                                </Grid>
                                                <Grid item xs={3}></Grid>
                                            </>
                                        }

                                        {/* <Grid container spacing={2} className='mt-1'> */}
                                        <Grid item xs={3}>
                                            <Typography component={'h3'} className='form-head-gray-title' sx={{
                                                backgroundColor: "transparent",
                                                fontWeight: 600
                                            }}>
                                                Employment Address
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={9} className='d-flex'>
                                            <FormControl error={Boolean(errors?.poa_emp_address_option)}>
                                                <Controller
                                                    name="poa_emp_address_option"
                                                    control={control}
                                                    rules={{ required: "Please select an option" }}
                                                    render={({ field }) => (
                                                        <RadioGroup
                                                            {...field}
                                                            row
                                                            value={field.value || ''}
                                                            aria-labelledby="poa-emp-address-option"
                                                            onChange={(e) => {
                                                                const value = Number(e.target.value);
                                                                field.onChange(value); // Update the form state

                                                                if (value === 2) {
                                                                    setValue('poa_emp_street_no', existingStreetNo || '', { shouldDirty: true });
                                                                    setValue('poa_emp_street_name', existingStreetName || '', { shouldDirty: true });
                                                                    setValue('poa_emp_apartment_no', existingApartmentNo || '', { shouldDirty: true });
                                                                    setValue('poa_emp_city', existingCity || '', { shouldDirty: true });
                                                                    setValue('poa_emp_postal_code', existingPostalCode || '', { shouldDirty: true });
                                                                    setValue('poa_emp_province', existingProvince || '', { shouldDirty: true });
                                                                    setValue('poa_emp_country', existingCountry || '', { shouldDirty: true });
                                                                } else if (value === 1) {
                                                                    setValue('poa_emp_street_no', '', { shouldDirty: true });
                                                                    setValue('poa_emp_street_name', '', { shouldDirty: true });
                                                                    setValue('poa_emp_apartment_no', '', { shouldDirty: true });
                                                                    setValue('poa_emp_city', '', { shouldDirty: true });
                                                                    setValue('poa_emp_postal_code', '', { shouldDirty: true });
                                                                    setValue('poa_emp_province', '', { shouldDirty: true });
                                                                    setValue('poa_emp_country', '', { shouldDirty: true });
                                                                }
                                                            }}
                                                        >
                                                            <FormControlLabel
                                                                value={1}
                                                                control={<Radio sx={radioColorSx} />}
                                                                label="As Specified Below"
                                                            />
                                                            <FormControlLabel
                                                                value={2}
                                                                control={<Radio sx={radioColorSx} />}
                                                                label="As Seen Above"
                                                            />
                                                        </RadioGroup>
                                                    )}
                                                />
                                            </FormControl>
                                        </Grid>

                                        <Grid item xs={4} className='pr-10px'>
                                            <TextField
                                                label="Street No"
                                                fullWidth
                                                size="small"
                                                id="poa_emp_street_no"
                                                {...register('poa_emp_street_no', { required: true })}
                                                error={Boolean(errors?.poa_emp_street_no)}
                                                InputLabelProps={{ shrink: !!wStreetNo }}
                                            />
                                        </Grid>

                                        <Grid item xs={4} className='pr-10px'>
                                            <TextField
                                                label="Street Name"
                                                fullWidth
                                                size="small"
                                                id="poa_emp_street_name"
                                                {...register('poa_emp_street_name', { required: true })}
                                                // value={watch('poa_emp_street_name') || ''}
                                                error={Boolean(errors?.poa_emp_street_name)}
                                                InputLabelProps={{ shrink: !!wStreetName }}
                                            />
                                        </Grid>

                                        <Grid item xs={4}>
                                            <TextField
                                                label="Apartment No"
                                                id="poa_emp_apartment_no"
                                                fullWidth
                                                size="small"
                                                {...register('poa_emp_apartment_no')}
                                                InputLabelProps={{ shrink: !!wAptNo }}
                                            // value={watch('poa_emp_apartment_no') || ''}
                                            />
                                        </Grid>

                                        <Grid item xs={6} className='pr-10px'>
                                            <TextField
                                                label="City"
                                                fullWidth
                                                size="small"
                                                id="poa_emp_city"
                                                {...register('poa_emp_city', { required: true })}
                                                // value={watch('poa_emp_city') || ''}
                                                error={Boolean(errors?.poa_emp_city)}
                                                InputLabelProps={{ shrink: !!wCity }}
                                            />
                                        </Grid>

                                        <Grid item xs={6}>
                                            <TextField
                                                label="Postal Code"
                                                fullWidth
                                                size="small"
                                                id="poa_emp_postal_code"
                                                {...register('poa_emp_postal_code', { required: true })}
                                                // value={watch('poa_emp_postal_code') || ''}
                                                error={Boolean(errors?.poa_emp_postal_code)}
                                                InputLabelProps={{ shrink: !!wPostal }}
                                            />
                                        </Grid>

                                        <Grid item xs={6} className='pr-10px'>
                                            <Controller
                                                name="poa_emp_province"
                                                control={control}
                                                defaultValue=""
                                                render={({ field }) => (
                                                    <TextField
                                                        select
                                                        fullWidth
                                                        size="small"
                                                        sx={{ mt: '8px' }}
                                                        label="Province"
                                                        // key="pEmpProvinceKey"
                                                        {...field} // Spreads RHF field props
                                                        error={Boolean(errors?.poa_emp_province)}
                                                        helperText={errors?.poa_emp_province?.message}
                                                    //  InputLabelProps={{ shrink: !!wProvince }}
                                                    >
                                                        {provinceList.map((option) => (
                                                            <MenuItem key={option.value} value={option.value}>
                                                                {option.label}
                                                            </MenuItem>
                                                        ))}
                                                    </TextField>
                                                )}
                                            />
                                        </Grid>

                                        <Grid item xs={6}>
                                            <Controller
                                                name="poa_emp_country"
                                                control={control}
                                                defaultValue={2}
                                                render={({ field }) => (
                                                    <TextField
                                                        select
                                                        fullWidth
                                                        size="small"
                                                        sx={{ mt: '8px' }}
                                                        label="Country"
                                                        // key="pEmpCountryKey"
                                                        {...field} // Uses RHF's field props
                                                        classes={{ select: "custom-select-label" }}
                                                        MenuProps={{
                                                            disableScrollLock: true,
                                                            PaperProps: { sx: { maxHeight: 200 } }
                                                        }}
                                                        error={Boolean(errors?.poa_emp_country)}
                                                        helperText={errors?.poa_emp_country?.message}
                                                    >
                                                        {countryList.map((option) => (
                                                            <MenuItem key={option.value} value={option.value}>
                                                                {option.label}
                                                            </MenuItem>
                                                        ))}
                                                    </TextField>
                                                )}
                                            />
                                        </Grid>
                                    </>
                                    : ''}
                            </>
                        )
                    }


                    <Grid item xs={12}>
                        <Typography component={'h5'} className='form-head-gray-title'>Insider</Typography>
                    </Grid>

                    <Grid item xs={12}>
                        <Alert
                            severity='info'
                            className='font14px  cursor-pointer'
                            onClick={handleClickInsiderOpen}
                        >
                            Click here for more information about Insider
                        </Alert>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-right'}`}>
                        <label htmlFor="red-insider" className='font15px pr-10px'>Insider </label>
                    </Grid>

                    <Grid item xs={12} sm={6} md={2}>
                        <FormControl component="fieldset" error={Boolean(errors?.regulatory_insider)}>
                            <Controller
                                name="regulatory_insider"
                                control={control}
                                rules={{ required: "This field is required" }}
                                render={({ field }) => (
                                    <RadioGroup {...field} row aria-labelledby="regulatory_insider" value={field.value || ''}>
                                        {radioOptionArray.map((option) => (
                                            <FormControlLabel
                                                key={option.value}
                                                value={option.value}
                                                control={<Radio sx={radioColorSx} />}
                                                label={option.label}
                                            />
                                        ))}
                                    </RadioGroup>
                                )}
                            />
                        </FormControl>

                    </Grid>
                    <Grid item xs={12} sm={12} md={6}></Grid>

                    <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-right'}`}>
                        <label htmlFor="regulatory-shareholder-ten" className='font15px pr-10px'>Shareholder(10%) </label>
                    </Grid>

                    <Grid item xs={12} sm={6} md={2}>
                        <FormControl component="fieldset" error={Boolean(errors?.regulatory_shareholder_ten)}>
                            <Controller
                                name="regulatory_shareholder_ten"
                                control={control}
                                rules={{ required: "This field is required" }}
                                render={({ field }) => (
                                    <RadioGroup {...field} row aria-labelledby="regulatory_shareholder_ten" value={field.value || ''}>
                                        {radioOptionArray.map((option) => (
                                            <FormControlLabel
                                                key={option.value}
                                                value={option.value}
                                                control={<Radio sx={radioColorSx} />}
                                                label={option.label}
                                            />
                                        ))}
                                    </RadioGroup>
                                )}
                            />
                        </FormControl>

                    </Grid>
                    <Grid item xs={12} sm={12} md={6}></Grid>



                    <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-right'}`}>
                        <label htmlFor="regulatory_shareholder_twenty" className='font15px pr-10px'>Shareholder(20%) </label>
                    </Grid>

                    <Grid item xs={12} sm={6} md={2}>
                        <FormControl component="fieldset" error={Boolean(errors?.regulatory_shareholder_twenty)}>
                            <Controller
                                name="regulatory_shareholder_twenty"
                                control={control}
                                rules={{ required: "This field is required" }}
                                render={({ field }) => (
                                    <RadioGroup {...field} row aria-labelledby="regulatory_shareholder_twenty" value={field.value || ''}>
                                        {radioOptionArray.map((option) => (
                                            <FormControlLabel
                                                key={option.value}
                                                value={option.value}
                                                control={<Radio sx={radioColorSx} />}
                                                label={option.label}
                                            />
                                        ))}
                                    </RadioGroup>
                                )}
                            />
                        </FormControl>

                    </Grid>
                    <Grid item xs={12} sm={12} md={6}></Grid>



                    <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-right'}`}>
                        <label htmlFor="red-insider" className='font15px pr-10px'>CIRO Member</label>
                    </Grid>

                    <Grid item xs={12} sm={6} md={2}>
                        <Controller
                            name="regulatory_ciro_member"
                            control={control}
                            defaultValue={2}
                            render={({ field }) => (
                                <FormControl component="fieldset">
                                    <RadioGroup
                                        row
                                        aria-labelledby="regulatory_ciro_member"
                                        {...field} // Uses RHF's field props
                                        value={field.value || ''}
                                    >
                                        {radioOptionArray.map((option) => (
                                            <FormControlLabel
                                                key={option.value}
                                                value={option.value}
                                                control={<Radio sx={radioColorSx} />}
                                                label={option.label}
                                            />
                                        ))}
                                    </RadioGroup>
                                </FormControl>
                            )}
                        />

                    </Grid>
                    <Grid item xs={12} sm={12} md={6}></Grid>


                    <Grid item xs={12}>
                        <Typography component={'h5'} className='form-head-gray-title'>Trusted Contact Member</Typography>
                    </Grid>


                    <Grid item xs={12}>
                        <Alert
                            severity='info'
                            className='font14px  cursor-pointer'
                            onClick={handleClickTcpOpen}
                        >
                            Click here to know more information about Trusted Contact Person
                        </Alert>
                    </Grid>


                    <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-right'}`}>
                        <label htmlFor="regulatory_trusted_contact" className='font15px pr-10px'>Do you wish to designate a trusted contact person?</label>
                    </Grid>

                    <Grid item xs={12} sm={6} md={2}>
                        <FormControl component="fieldset" error={Boolean(errors?.regulatory_trusted_contact)}>
                            <Controller
                                name="regulatory_trusted_contact"
                                control={control}
                                rules={{ required: "This field is required" }}
                                render={({ field }) => (
                                    <RadioGroup {...field} row aria-labelledby="regulatory_trusted_contact" value={field.value || ''}>
                                        {radioOptionArray.map((option) => (
                                            <FormControlLabel
                                                key={option.value}
                                                value={option.value}
                                                control={<Radio sx={radioColorSx} />}
                                                label={option.label}
                                            />
                                        ))}
                                    </RadioGroup>
                                )}
                            />
                        </FormControl>

                    </Grid>
                    <Grid item xs={12} sm={12} md={6}></Grid>

                    {regulatoryTrustedContact == 1 ?
                        <>
                            <Grid item container spacing={3}>
                                <Grid item xs={12}>
                                    <Typography component={'h3'} className='form-head-gray-title p-0' sx={{
                                        backgroundColor: "transparent",
                                        fontWeight: 600
                                    }}
                                    >
                                        Client
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} sm={3} className='pr-10px'>
                                    {/* <TextField fullWidth label="TCP Name" variant="outlined" size="small" /> */}
                                    <TextField
                                        label="Name"
                                        variant="outlined"
                                        fullWidth
                                        size="small"
                                        margin="dense"
                                        id="tcp_client_name"
                                        {...register('tcp_client_name', { required: true })}
                                        error={Boolean(errors?.tcp_client_name)}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={3} className='pr-10px'>
                                    <TextField
                                        label="Phone no"
                                        variant="outlined"
                                        fullWidth
                                        size="small"
                                        margin="dense"
                                        id="tcp_client_phone_no"
                                        {...register('tcp_client_phone_no', { required: true })}
                                        error={Boolean(errors?.tcp_client_phone_no)}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={3} className='pr-10px'>
                                    <TextField
                                        label="Email"
                                        variant="outlined"
                                        fullWidth
                                        size="small"
                                        margin="dense"
                                        id="tcp_client_email"
                                        {...register('tcp_client_email', { required: true })}
                                        error={Boolean(errors?.tcp_client_email)}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={3} sx={{ marginTop: '7px' }}>
                                    <FormControl
                                        sx={{ minWidth: 200 }}
                                        size="small"
                                        error={Boolean(errors?.tcp_client_relationship_to_you)}
                                    >
                                        <InputLabel id="tcp-client-relationship-to-you">Relationship to you</InputLabel>
                                        <Controller
                                            name="tcp_client_relationship_to_you"
                                            control={control}
                                            rules={{ required: "Relationship is required" }}
                                            render={({ field }) => (
                                                <Select
                                                    {...field}
                                                    value={field.value ?? ''}
                                                    labelId="tcp-client-relationship-to-you"
                                                    label="Relationship to you"
                                                    MenuProps={{
                                                        disableScrollLock: true,
                                                        PaperProps: { sx: { maxHeight: 200 } }
                                                    }}
                                                >
                                                    {relationshipList?.map((row) => (
                                                        <MenuItem key={row.value} value={row.value}>
                                                            {row.label}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            )}
                                        />
                                    </FormControl>

                                </Grid>
                            </Grid>

                            {/* Joint Applicant */}


                            <Grid item container spacing={3}>
                                <Grid item xs={12}>
                                    <Typography component={'h3'} className='form-head-gray-title p-0' sx={{
                                        backgroundColor: "transparent",
                                        fontWeight: 600
                                    }}>
                                        Joint Applicant
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} sm={3} className='pr-10px'>
                                    <TextField
                                        label="Name"
                                        variant="outlined"
                                        fullWidth
                                        size="small"
                                        margin="dense"
                                        id="tcp_joint_app_name"
                                        {...register('tcp_joint_app_name')}
                                    // error={Boolean(errors?.tcp_joint_app_name)}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={3} className='pr-10px'>
                                    <TextField
                                        label="Phone no"
                                        variant="outlined"
                                        fullWidth
                                        size="small"
                                        margin="dense"
                                        id="tcp_joint_app_phone_no"
                                        {...register('tcp_joint_app_phone_no')}
                                    // error={Boolean(errors?.tcp_joint_app_phone_no)}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={3} className='pr-10px'>
                                    <TextField
                                        label="Email"
                                        variant="outlined"
                                        fullWidth
                                        size="small"
                                        margin="dense"
                                        id="tcp_joint_app_email"
                                        {...register('tcp_joint_app_email')}
                                    // error={Boolean(errors?.tcp_joint_app_email)}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={3} sx={{ marginTop: '7px' }}>
                                    <FormControl sx={{ minWidth: 200 }} size="small">
                                        <InputLabel id="tcp-joint-app-relationship-to-you">Relationship to you</InputLabel>
                                        <Controller
                                            name="tcp_joint_app_relationship_to_you"
                                            control={control}
                                            render={({ field }) => (
                                                <Select
                                                    {...field}
                                                    value={field.value ?? ''}
                                                    labelId="tcp-joint-app-relationship-to-you"
                                                    label="Relationship to you"
                                                    MenuProps={{
                                                        disableScrollLock: true,
                                                        PaperProps: { sx: { maxHeight: 200 } }
                                                    }}
                                                >
                                                    {relationshipList?.map((row) => (
                                                        <MenuItem key={row.value} value={row.value}>
                                                            {row.label}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            )}
                                        />
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </>
                        :
                        <Grid item container spacing={3}>
                            <Grid item xs={12}>
                                <label className="label-text font14px" htmlFor="trustedContactExplanation">
                                    Explain No Trusted Contact
                                </label>
                            </Grid>
                            <Grid item xs={12} sm={6} className='pr-10px'>
                                <div className="grid-item margin-bottom20px">
                                    <InputBase
                                        className="textarea-mui"
                                        name='tcp_decline_note'
                                        id='tcp_decline_notes'
                                        {...register('tcp_decline_note')}
                                        // placeholder={`Enter ${label.toLowerCase()}`}
                                        multiline
                                        minRows={3}
                                        maxRows={5}
                                        fullWidth
                                    />
                                </div>
                            </Grid>
                        </Grid>
                    }


                    {/* ===========================PEP/HIO =============================== */}
                    <Grid item xs={12}>
                        <Typography component={'h5'} className='form-head-gray-title'>Politically Exposed Persons (PEP) / Head of international Org (HIO)</Typography>
                    </Grid>


                    <Grid item xs={12}>
                        <Alert
                            severity='info'
                            className='font14px cursor-pointer'
                            onClick={handleClickPepOpen}
                        >
                            Click here for more information about PEP/HIO
                        </Alert>
                    </Grid>


                    <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-left'}`}>
                        <label htmlFor="regulatory_foreign_pep" className='font15px pr-10px'>Are you a Foreign PEP?</label>
                    </Grid>
                    <Grid item xs={12} sm={6} md={2}>
                        <FormControl component="fieldset" error={Boolean(errors?.regulatory_foreign_pep)}>
                            <Controller
                                name="regulatory_foreign_pep"
                                control={control}
                                rules={{ required: "This field is required" }}
                                render={({ field }) => (
                                    <RadioGroup
                                        {...field}
                                        row
                                        aria-labelledby="regulatory_foreign_pep"
                                        value={field.value || ''}
                                    >
                                        {radioOptionArray.map((option) => (
                                            <FormControlLabel
                                                key={option.value}
                                                value={option.value}
                                                control={<Radio sx={radioColorSx} />}
                                                label={option.label}
                                            />
                                        ))}
                                    </RadioGroup>
                                )}
                            />
                        </FormControl>

                    </Grid>
                    <Grid item xs={12} sm={12} md={6}></Grid>




                    <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-left'}`}>
                        <label htmlFor="regulatory_associated_foreign_pep" className='font15px pr-10px'>Are you family member or close associate of a  foreign PEP?</label>
                    </Grid>
                    <Grid item xs={12} sm={6} md={2}>
                        <FormControl component="fieldset" error={Boolean(errors?.regulatory_associated_foreign_pep)}>
                            <Controller
                                name="regulatory_associated_foreign_pep"
                                control={control}
                                rules={{ required: "This field is required" }}
                                render={({ field }) => (
                                    <RadioGroup {...field} value={field.value || ''} row aria-labelledby="regulatory_associated_foreign_pep">
                                        {radioOptionArray.map((option) => (
                                            <FormControlLabel
                                                key={option.value}
                                                value={option.value}
                                                control={<Radio sx={radioColorSx} />}
                                                label={option.label}
                                            />
                                        ))}
                                    </RadioGroup>
                                )}
                            />
                        </FormControl>

                    </Grid>
                    <Grid item xs={12} sm={12} md={6}></Grid>



                    <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-left'}`}>
                        <label htmlFor="regulatory_domestic_pep" className='font15px pr-10px'>Are you domestic PEP?</label>
                    </Grid>
                    <Grid item xs={12} sm={6} md={2}>
                        <FormControl component="fieldset" error={Boolean(errors?.regulatory_domestic_pep)}>
                            <Controller
                                name="regulatory_domestic_pep"
                                control={control}
                                rules={{ required: "This field is required" }}
                                render={({ field }) => (
                                    <RadioGroup {...field} value={field.value || ''} row aria-labelledby="regulatory_domestic_pep">
                                        {radioOptionArray.map((option) => (
                                            <FormControlLabel
                                                key={option.value}
                                                value={option.value}
                                                control={<Radio sx={radioColorSx} />}
                                                label={option.label}
                                            />
                                        ))}
                                    </RadioGroup>
                                )}
                            />
                        </FormControl>

                    </Grid>
                    <Grid item xs={12} sm={12} md={6}></Grid>



                    <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-left'}`}>
                        <label htmlFor="regulatory_associated_domestic_pep" className='font15px pr-10px'>Are you family member or close associate of a  domestic PEP?</label>
                    </Grid>
                    <Grid item xs={12} sm={6} md={2}>
                        <FormControl component="fieldset" error={Boolean(errors?.regulatory_associated_domestic_pep)}>
                            <Controller
                                name="regulatory_associated_domestic_pep"
                                control={control}
                                rules={{ required: "This field is required" }}
                                render={({ field }) => (
                                    <RadioGroup {...field} value={field.value || ''} row aria-labelledby="regulatory_associated_domestic_pep">
                                        {radioOptionArray.map((option) => (
                                            <FormControlLabel
                                                key={option.value}
                                                value={option.value}
                                                control={<Radio sx={radioColorSx} />}
                                                label={option.label}
                                            />
                                        ))}
                                    </RadioGroup>
                                )}
                            />
                        </FormControl>

                    </Grid>
                    <Grid item xs={12} sm={12} md={6}></Grid>



                    <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-left'}`}>
                        <label htmlFor="regulatory_hio" className='font15px'>Are you a HIO?</label>
                    </Grid>
                    <Grid item xs={12} sm={6} md={2}>
                        <FormControl component="fieldset" error={Boolean(errors?.regulatory_hio)}>
                            <Controller
                                name="regulatory_hio"
                                control={control}
                                rules={{ required: "This field is required" }}
                                render={({ field }) => (
                                    <RadioGroup {...field} value={field.value || ''} row aria-labelledby="regulatory_hio">
                                        {radioOptionArray.map((option) => (
                                            <FormControlLabel
                                                key={option.value}
                                                value={option.value}
                                                control={<Radio sx={radioColorSx} />}
                                                label={option.label}
                                            />
                                        ))}
                                    </RadioGroup>
                                )}
                            />
                        </FormControl>

                    </Grid>
                    <Grid item xs={12} sm={12} md={6}></Grid>



                    <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-left'}`}>
                        <label htmlFor="regulatory_associated_hio" className='font15px pr-10px'>Are you family member or close associate of a  HIO?</label>
                    </Grid>
                    <Grid item xs={12} sm={6} md={2}>
                        <FormControl component="fieldset" error={Boolean(errors?.regulatory_associated_hio)}>
                            <Controller
                                name="regulatory_associated_hio"
                                control={control}
                                rules={{ required: "This field is required" }}
                                render={({ field }) => (
                                    <RadioGroup {...field} value={field.value || ''} row aria-labelledby="regulatory_associated_hio">
                                        {radioOptionArray.map((option) => (
                                            <FormControlLabel
                                                key={option.value}
                                                value={option.value}
                                                control={<Radio sx={radioColorSx} />}
                                                label={option.label}
                                            />
                                        ))}
                                    </RadioGroup>
                                )}
                            />
                        </FormControl>

                    </Grid>
                    <Grid item xs={12} sm={12} md={6}></Grid>

                    {/* ----------------------------------------------------AML & QI Verification ---------------------------- */}
                    <Grid item xs={12}>
                        <Typography variant='h3' className='form-head-gray-title'>AML & QI Verification</Typography>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-left'}`}>
                        <label htmlFor="aml_representative_register" className='font15px'>Is there representative register in the province or country of the account holder?</label>
                    </Grid>
                    <Grid item xs={12} sm={6} md={2}>
                        <FormControl component="fieldset">
                            <Controller
                                name="aml_representative_register"
                                control={control}
                                defaultValue={1}
                                render={({ field: { onChange, value }, fieldState: { error } }) => (
                                    <RadioGroup
                                        row
                                        aria-labelledby="aml_representative_register"
                                        value={value}
                                        onChange={(e) => {
                                            onChange(e); // RHF handles state
                                            // changeRegulatoryInfo(e); // your custom logic
                                        }}
                                    >
                                        {radioOptionArray.map((option) => (
                                            <FormControlLabel
                                                key={option.value}
                                                value={option.value}
                                                control={<Radio sx={radioColorSx} />}
                                                label={option.label}
                                            />
                                        ))}
                                    </RadioGroup>
                                )}
                            />
                        </FormControl>

                    </Grid>
                    <Grid item xs={12} sm={12} md={6}></Grid>

                    <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-left'}`}>
                        <label htmlFor="select-contact-application" className='font15px'>What is the origin of your contact with the applicant?</label>
                    </Grid>


                    <Grid item xs={12} sm={6} md={2}>
                        <FormControl
                            sx={{ minWidth: 200 }}
                            fullWidth
                            size="small"
                            error={Boolean(errors?.regulatory_contact_application)}
                        >
                            <InputLabel id="select-contact-application">Contact</InputLabel>

                            <Controller
                                name="regulatory_contact_application"
                                control={control}
                                defaultValue={3}
                                rules={{ required: true }}
                                render={({ field }) => (
                                    <Select
                                        {...field}
                                        value={field.value}
                                        labelId="select-contact-application"
                                        label="Contact"
                                        MenuProps={{
                                            disableScrollLock: true,
                                            PaperProps: { sx: { maxHeight: 200 } },
                                        }}
                                    >
                                        {originOfContactList.map((option) => (
                                            <MenuItem key={option.value} value={option.value}>
                                                {option.label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                )}
                            />
                        </FormControl>

                    </Grid>
                    <Grid item xs={12} sm={12} md={6}></Grid>


                    <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-left'}`}>
                        <label className='font15px'>How long have you known the applicant?</label>
                    </Grid>
                    <Grid item xs={12} sm={6} md={2}>
                        <TextField
                            label="Years"
                            size="small"
                            id="known-applicant-years"
                            {...register('known_applicant_years')}
                        // error={Boolean(errors && errors['known_applicant_years'])}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} md={2}>
                        <TextField
                            label="Months"
                            size="small"
                            id="known_applicant_months"
                            {...register('known_applicant_months')}
                        // error={Boolean(errors && errors['known_applicant_months'])}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}></Grid>



                    <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-left'}`}>
                        <label htmlFor="aml-in-person-verification" className='font15px'>Have you met the applicant in person to conduct tha AML & QI verification?</label>
                    </Grid>

                    <Grid item xs={12} sm={6} md={2}>
                        <FormControl component="fieldset">
                            <Controller
                                name="aml_in_person_verification"
                                control={control}
                                defaultValue={''} // or your preferred default like 1, 'yes', etc.
                                render={({ field: { onChange, value }, fieldState: { error } }) => (
                                    <RadioGroup
                                        row
                                        aria-labelledby="aml_in_person_verification"
                                        value={value}
                                        onChange={(e) => {
                                            onChange(e); // RHF state update
                                            // changeRegulatoryInfo(e); // your handler
                                        }}
                                    >
                                        {radioOptionArray.map((option) => (
                                            <FormControlLabel
                                                key={option.value}
                                                value={option.value}
                                                control={<Radio sx={radioColorSx} />}
                                                label={option.label}
                                            />
                                        ))}
                                    </RadioGroup>
                                )}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}></Grid>



                    <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-left'}`}>
                        <label htmlFor="select-aml-application" className='font15px'>AML/QI method</label>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <FormControl
                            fullWidth
                            size="small"
                            error={Boolean(errors?.aml_method)}
                        >
                            <InputLabel id="select-aml-method">AML/QI method</InputLabel>

                            <Controller
                                name="aml_method"
                                control={control}
                                defaultValue=""
                                rules={{ required: true }}
                                render={({ field: { onChange, value }, fieldState: { error } }) => (
                                    <Select
                                        labelId="select-aml-method"
                                        label="AML/QI method"
                                        value={value}
                                        onChange={(e) => {
                                            onChange(e); // RHF internal update
                                            // changeRegulatoryInfo(e); // your custom logic
                                        }}
                                        classes={{ select: "custom-select-label" }}
                                        MenuProps={{
                                            disableScrollLock: true,
                                            PaperProps: { sx: { maxHeight: 200 } },
                                        }}
                                    >
                                        {AmlQiVerificationList.map((option) => (
                                            <MenuItem key={option.value} value={option.value}>
                                                {option.label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                )}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={4}></Grid>






                    {/* ================upload multiple documents ============= */}
                    <Grid item xs={12}>
                        <Typography variant='h3' className='form-head-gray-title'>Identification Documents</Typography>
                    </Grid>

                    <Box
                        sx={{
                            // height: 400,
                            marginTop: 1,
                            width: 1,
                            '& .odd': {
                                bgcolor: '#f5f5f5'
                            },
                            '& .even': {
                                bgcolor: '#eee'
                            }
                        }}
                    >
                        <div className="upload-section">
                            <p className="upload-section-subtitle">
                                Supported files: PDF, PNG, JPEG, JPG. Maximum file size: 2 MB.
                            </p>
                            <div className="upload-container">
                                <div className="upload-item">
                                    <label htmlFor="idProof" className="upload-label">ID Proof:</label>
                                    <div className="upload-input-wrapper">
                                        {files.id_proof_file ?
                                            <span className="file-details">
                                                <span className="file-name">{files.id_proof_file}</span>
                                                <IconButton
                                                    aria-label="Download file"
                                                    onClick={() => downloadHandler(files.id_proof_file, 1)}
                                                >
                                                    <DownloadIcon />
                                                </IconButton>
                                                <IconButton
                                                    aria-label="Delete file"
                                                    onClick={() => deleteHandler("id_proof_file", 1)}
                                                >
                                                    <DeleteIcon />
                                                </IconButton>
                                            </span>
                                            :
                                            <>
                                                <Button startIcon={<CloudUploadIcon />} variant="outlined" component="label">
                                                    Upload
                                                    <input
                                                        type="file"
                                                        hidden
                                                        accept=".pdf,.jpeg,.jpg,.png"
                                                        onChange={(e) => uploadHandler(e, "id_proof_file")}
                                                    />
                                                </Button>
                                            </>
                                        }
                                    </div>
                                </div>
                                <div className="upload-item">
                                    <label htmlFor="driverLicense" className="upload-label">Driver License:</label>
                                    <div className="upload-input-wrapper">
                                        {
                                            files.driver_license_file ?
                                                <span className="file-details">
                                                    <span className="file-name">{files.driver_license_file}</span>
                                                    <IconButton
                                                        aria-label="Download file"
                                                        onClick={() => downloadHandler(files.driver_license_file, 2)}
                                                    >
                                                        <DownloadIcon />
                                                    </IconButton>
                                                    <IconButton
                                                        aria-label="Delete file"
                                                        onClick={() => deleteHandler("driver_license_file", 2)}
                                                    >
                                                        <DeleteIcon />
                                                    </IconButton>
                                                </span>
                                                :
                                                <>
                                                    <Button startIcon={<CloudUploadIcon />} variant="outlined" component="label">
                                                        Upload
                                                        <input
                                                            type="file"
                                                            hidden
                                                            // id="driverLicense"
                                                            accept=".pdf,.jpeg,.jpg,.png"
                                                            onChange={(e) => uploadHandler(e, "driver_license_file")}
                                                        />
                                                    </Button>
                                                </>
                                        }

                                    </div>
                                </div>
                                <div className="upload-item">
                                    <label htmlFor="passport" className="upload-label">Passport:</label>
                                    <div className="upload-input-wrapper">

                                        {
                                            files.passport_file ?
                                                <span className="file-details">
                                                    <span className="file-name">{files.passport_file}</span>
                                                    <IconButton
                                                        aria-label="Download file"
                                                        onClick={() => downloadHandler(files.passport_file, 3)}
                                                    >
                                                        <DownloadIcon />
                                                    </IconButton>
                                                    <IconButton
                                                        aria-label="Delete file"
                                                        onClick={() => deleteHandler("passport_file", 3)}
                                                    >
                                                        <DeleteIcon />
                                                    </IconButton>
                                                </span>
                                                :
                                                <>
                                                    <Button startIcon={<CloudUploadIcon />} variant="outlined" component="label">
                                                        Upload
                                                        <input
                                                            type="file"
                                                            hidden
                                                            // id="passport"
                                                            accept=".pdf,.jpeg,.jpg,.png"
                                                            onChange={(e) => uploadHandler(e, "passport_file")}
                                                        />
                                                    </Button>
                                                </>
                                        }
                                        {/* {files.passport_file && <span className="file-name">{files.passport_file}</span>} */}
                                    </div>
                                </div>
                                <div className="upload-item">
                                    <label htmlFor="other" className="upload-label">Other:</label>
                                    <div className="upload-input-wrapper">
                                        {
                                            files.other_file ?
                                                <span className="file-details">
                                                    <span className="file-name">{files.other_file}</span>
                                                    <IconButton
                                                        aria-label="Download file"
                                                        onClick={() => downloadHandler(files.other_file, 4)}
                                                    >
                                                        <DownloadIcon />
                                                    </IconButton>
                                                    <IconButton
                                                        aria-label="Delete file"
                                                        onClick={() => deleteHandler("other_file", 4)}
                                                    >
                                                        <DeleteIcon />
                                                    </IconButton>
                                                </span>
                                                :
                                                <>
                                                    <Button startIcon={<CloudUploadIcon />} variant="outlined" component="label">
                                                        Upload
                                                        <input
                                                            type="file"
                                                            hidden
                                                            // id="other"
                                                            accept=".pdf,.jpeg,.jpg,.png"
                                                            onChange={(e) => uploadHandler(e, "other_file")}
                                                        />
                                                    </Button>
                                                </>
                                        }
                                        {/* {files.other_file && <span className="file-name">{files.other_file}</span>} */}
                                    </div>
                                </div>

                                {/* -------- void cheque -------- */}

                                <div className="upload-item">
                                    <label htmlFor="voidCheque" className="upload-label">Void Cheque:</label>
                                    <div className="upload-input-wrapper">
                                        {
                                            files.void_cheque_file ?
                                                <span className="file-details">
                                                    <span className="file-name">{files.void_cheque_file}</span>
                                                    <IconButton
                                                        aria-label="Download file"
                                                        onClick={() => downloadHandler(files.void_cheque_file, 5)}
                                                    >
                                                        <DownloadIcon />
                                                    </IconButton>
                                                    <IconButton
                                                        aria-label="Delete file"
                                                        onClick={() => deleteHandler("void_cheque_file", 5)}
                                                    >
                                                        <DeleteIcon />
                                                    </IconButton>
                                                </span>
                                                :
                                                <>
                                                    <Button startIcon={<CloudUploadIcon />} variant="outlined" component="label">
                                                        Upload
                                                        <input
                                                            type="file"
                                                            // className="upload-input"
                                                            // id="voidCheque"
                                                            hidden
                                                            accept=".pdf,.jpeg,.jpg,.png"
                                                            onChange={(e) => uploadHandler(e, "void_cheque_file")}
                                                        />
                                                    </Button>
                                                </>
                                        }
                                        {/* {files.driver_license_file && <span className="file-name">{files.driver_license_file}</span>} */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Box>

                    {/* =====0990============================================================== */}

                    <Grid item xs={12}>
                        <Typography variant='h3' className='form-head-gray-title'>Id Verification</Typography>
                    </Grid>


                    <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-left'}`}>
                        <label htmlFor="dl-id-number" className='font15px'>ID Number</label>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <TextField
                            label="ID Number"
                            size="small"
                            fullWidth
                            id="dl-id-number"
                            {...register('dl_number', { required: true })}
                            error={Boolean(errors && errors['dl_number'])}
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} md={4}></Grid>


                    <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-left'}`}>
                        <label htmlFor="dl-dob-number" className='font15px'>Date of Birth</label>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <Stack spacing={3}>
                                <Controller
                                    name="dl_dob"
                                    control={control}
                                    defaultValue={null} // can be a Date object or null
                                    render={({ field: { onChange, value }, fieldState: { error } }) => (
                                        <DesktopDatePicker
                                            disableFuture
                                            label="Date Of Birth"
                                            inputFormat="yyyy/MM/dd"
                                            value={value}
                                            onChange={(date) => onChange(date)}
                                            minDate={new Date('1949-01-01')}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    fullWidth
                                                    size="small"
                                                    error={!!error}
                                                    helperText={error?.message}
                                                />
                                            )}
                                        />
                                    )}
                                />
                            </Stack>
                        </LocalizationProvider>

                    </Grid>
                    <Grid item xs={12} sm={12} md={4}></Grid>


                    <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-left'}`}>
                        <label htmlFor="dl-doi-number" className='font15px'>Date of Issue</label>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <Stack spacing={3}>
                                <Controller
                                    name="dl_doi"
                                    control={control}
                                    defaultValue={null}
                                    render={({ field: { onChange, value }, fieldState: { error } }) => (
                                        <DesktopDatePicker
                                            disableFuture
                                            label="Date Of Issue"
                                            inputFormat="yyyy/MM/dd"
                                            value={value}
                                            onChange={(date) => onChange(date)}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    fullWidth
                                                    size="small"
                                                    error={!!error}
                                                    helperText={error?.message}
                                                />
                                            )}
                                        />
                                    )}
                                />
                            </Stack>
                        </LocalizationProvider>


                    </Grid>
                    <Grid item xs={12} sm={12} md={4}></Grid>


                    <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-left'}`}>
                        <label htmlFor="dl-doe-number" className='font15px'>Date of Expiry</label>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <Stack spacing={3}>
                                <Controller
                                    name="dl_doe"
                                    control={control}
                                    defaultValue={null}
                                    render={({ field: { onChange, value }, fieldState: { error } }) => (
                                        <DesktopDatePicker
                                            label="Date Of Expiry"
                                            inputFormat="yyyy/MM/dd"
                                            value={value}
                                            onChange={(date) => onChange(date)}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    fullWidth
                                                    size="small"
                                                    error={!!error}
                                                    helperText={error?.message}
                                                />
                                            )}
                                        />
                                    )}
                                />
                            </Stack>
                        </LocalizationProvider>
                    </Grid>
                    <Grid item xs={12} sm={12} md={4}></Grid>

                    <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-left'}`}>
                        <label className='font15px'>Province or Territory where License was issued</label>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <FormControl fullWidth size="small" error={Boolean(errors?.dl_issued_province)}>
                            <InputLabel id="select-dl-issued-province">Province</InputLabel>

                            <Controller
                                name="dl_issued_province"
                                control={control}
                                defaultValue=""
                                render={({ field: { onChange, value }, fieldState: { error } }) => (
                                    <Select
                                        labelId="select-dl-issued-province"
                                        label="Province"
                                        value={value}
                                        onChange={onChange}
                                        classes={{ select: "custom-select-label" }}
                                        MenuProps={{
                                            disableScrollLock: true,
                                            PaperProps: { sx: { maxHeight: 200 } },
                                        }}
                                    >
                                        {provinceList.map((option) => (
                                            <MenuItem key={option.value} value={option.value}>
                                                {option.label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                )}
                            />
                        </FormControl>

                    </Grid>
                    <Grid item xs={12} sm={12} md={4}></Grid>


                    <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-left'}`}>
                        <label htmlFor="dl-dov" className='font15px'>Date of Document Verification</label>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <Stack spacing={3}>
                                <Controller
                                    name="dl_date_dov"
                                    control={control}
                                    defaultValue={null}
                                    render={({ field: { onChange, value }, fieldState: { error } }) => (
                                        <DesktopDatePicker
                                            disableFuture
                                            label="Date Of Document Verification"
                                            inputFormat="yyyy/MM/dd"
                                            value={value}
                                            onChange={(date) => onChange(date)}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    fullWidth
                                                    size="small"
                                                    error={!!error}
                                                    helperText={error?.message}
                                                />
                                            )}
                                        />
                                    )}
                                />
                            </Stack>
                        </LocalizationProvider>

                    </Grid>
                    <Grid item xs={12} sm={12} md={4}></Grid>

                    {/* ==================CLIENT GROUP INFORMATION DATA ================ */}

                    <Grid container spacing={2} className='p-4'>

                        <Grid item xs={12}>
                            <Typography variant='h3' className='form-head-gray-title'>CLIENT GROUP INFORMATION</Typography>
                        </Grid>

                        {/* Source of Initial Investment */}
                        <Grid item xs={12} sm={6} md={6} className={`mt-3 align-self-start`}>
                            <label htmlFor="source_initial_investment" className='font15px'>Source of initial Investment</label>
                        </Grid>

                        <Grid item xs={12} sm={6} md={6}>
                            <FormControl required component="fieldset" variant="standard" error={Boolean(errors?.source_initial_investment)}>
                                <FormGroup>
                                    {initialInvestmentArray.map((option) => (
                                        <Controller
                                            key={option.value}
                                            name="source_initial_investment"
                                            control={control}
                                            render={({ field }) => (
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            sx={checkboxColorSx}
                                                            checked={field.value?.includes(option.value) || false}
                                                            onChange={(e) => {
                                                                const updatedInvestment = e.target.checked
                                                                    ? [...(field.value || []), option.value] // Add if checked
                                                                    : field.value.filter((val) => val !== option.value); // Remove if unchecked
                                                                field.onChange(updatedInvestment);
                                                            }}
                                                        />
                                                    }
                                                    label={option.label}
                                                />
                                            )}
                                        />
                                    ))}
                                </FormGroup>
                            </FormControl>
                        </Grid>

                        {/* Fee Type */}
                        {/* <Grid item xs={12} sm={6} md={6} className={`align-content-center`}>
                                    <label htmlFor="fee-type" className='font15px'>Fee Type</label>
                                </Grid>
                                <Grid item xs={12} sm={6} md={6}>
                                    <FormControl component="fieldset">
                                        <RadioGroup
                                            row
                                            id='fee-type'
                                            aria-labelledby="fee-type"
                                            name='client_fee_type'
                                            value={formState[rowAccountType.id]?.client_fee_type || ''}
                                            onChange={(e) => handleChange(e, rowAccountType.id)}
                                        >
                                            <FormControlLabel
                                                value='1'
                                                control={<Radio sx={radioColorSx} />}
                                                label='Hybrid'
                                            />
                                        </RadioGroup>
                                    </FormControl>
                                </Grid> */}

                        {/* Disclosure of Beneficial Ownership */}
                        <Grid item xs={12} sm={6} md={6} className={`align-content-center`}>
                            <label htmlFor="client-ownership" className='font15px'>Disclosure of beneficial Ownership information.</label>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6}>
                            <FormControl component="fieldset" error={Boolean(errors?.client_ownership)}>
                                <Controller
                                    name="client_ownership"
                                    control={control}
                                    defaultValue="1"
                                    render={({ field }) => (
                                        <RadioGroup {...field} value={field.value || ''} row id="client-ownership" aria-labelledby="client-ownership">
                                            <FormControlLabel
                                                value="1"
                                                control={<Radio sx={radioColorSx} />}
                                                label="I Object"
                                            />
                                            <FormControlLabel
                                                value="2"
                                                control={<Radio sx={radioColorSx} />}
                                                label="I Do Not Object"
                                            />
                                        </RadioGroup>
                                    )}
                                />
                            </FormControl>
                        </Grid>
                        {/* Receiving Security Holder Materials */}
                        <Grid item xs={12} sm={6} md={6} className={`align-content-center`}>
                            <label htmlFor="client-holder-material" className='font15px'>Receiving Security Holder Materials</label>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6}>
                            <FormControl component="fieldset" error={Boolean(errors?.client_holder_material)}>
                                <Controller
                                    name="client_holder_material"
                                    control={control}
                                    defaultValue="2"
                                    render={({ field }) => (
                                        <RadioGroup
                                            {...field}
                                            value={field.value || ''}
                                            row
                                            id="client-holder-material"
                                            aria-labelledby="client-holder-material"
                                        >
                                            {holderMaterialsOptions.map((option) => (
                                                <FormControlLabel
                                                    key={option.value}
                                                    value={option.value}
                                                    control={<Radio sx={radioColorSx} />}
                                                    label={option.label}
                                                />
                                            ))}
                                        </RadioGroup>
                                    )}
                                />
                            </FormControl>
                        </Grid>


                        {/* Consent to Electronic Delivery */}
                        <Grid item xs={12} sm={6} md={6} className={`align-content-center`}>
                            <label htmlFor="client-electronic-delivery" className='font15px'>Consent to Electronic Delivery</label>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6}>
                            <FormControl component="fieldset">
                                <Controller
                                    name="client_electronic_delivery"
                                    control={control}
                                    // rules={{ required: "This field is required" }}
                                    render={({ field }) => (
                                        <RadioGroup row id="client-electronic-delivery" {...field} value={field.value || ''}>
                                            {[
                                                { value: "1", label: "I Consent" },
                                                { value: "2", label: "I Do Not Consent" }
                                            ].map((option) => (
                                                <FormControlLabel
                                                    key={option.value}
                                                    value={option.value}
                                                    control={<Radio sx={radioColorSx} />}
                                                    label={option.label}
                                                />
                                            ))}
                                        </RadioGroup>
                                    )}
                                />
                            </FormControl>
                        </Grid>


                        {/* Client Want Statement */}
                        <Grid item xs={12} sm={6} md={6} className={`align-content-center`}>
                            <label htmlFor="client-want-statement" className='font15px'>Will the client want to view account, account statement, trade confirmation or other documents via the investor portal website</label>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6}>
                            <FormControl component="fieldset">
                                <Controller
                                    name="client_view_statement"
                                    control={control}
                                    rules={{ required: "This field is required" }}
                                    render={({ field }) => (
                                        <RadioGroup row id="client-want-statement" {...field} value={field.value || ''}>
                                            {radioOptionArray.map((option) => (
                                                <FormControlLabel
                                                    key={option.value}
                                                    value={option.value}
                                                    control={<Radio sx={radioColorSx} />}
                                                    label={option.label}
                                                />
                                            ))}
                                        </RadioGroup>
                                    )}
                                />
                            </FormControl>
                        </Grid>

                        {/* Client Waive Trade Confirmations */}
                        <Grid item xs={12} sm={6} md={6} className={`align-content-center`}>
                            <label htmlFor="client-waive-trade-confirmations" className='font15px'>Does the Client wish to waive their right to receive trade confirmations?</label>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6}>
                            <FormControl component="fieldset">
                                <Controller
                                    name="client_waive_trade_confirmations"
                                    control={control}
                                    rules={{ required: "This field is required" }}
                                    render={({ field }) => (
                                        <RadioGroup row id="client-waive-trade-confirmations" {...field} value={field.value || ''}>
                                            {radioOptionArray.map((option) => (
                                                <FormControlLabel
                                                    key={option.value}
                                                    value={option.value}
                                                    control={<Radio sx={radioColorSx} />}
                                                    label={option.label}
                                                />
                                            ))}
                                        </RadioGroup>
                                    )}
                                />
                            </FormControl>

                        </Grid>

                        {/* Third Party Financial Interest */}
                        <Grid item xs={12} sm={6} md={6} className={`align-content-center`}>
                            <label htmlFor="client-third-party-interest" className='font15px'>Is there a third party financial interest?</label>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6}>
                            <FormControl component="fieldset">
                                <Controller
                                    name="client_third_party_financial_interest"
                                    control={control}
                                    rules={{ required: "This field is required" }}
                                    render={({ field }) => (
                                        <RadioGroup row id="client-third-party-interest" {...field} value={field.value || ''}>
                                            {radioOptionArray.map((option) => (
                                                <FormControlLabel
                                                    key={option.value}
                                                    value={option.value}
                                                    control={<Radio sx={radioColorSx} />}
                                                    label={option.label}
                                                />
                                            ))}
                                        </RadioGroup>
                                    )}
                                />
                            </FormControl>
                        </Grid>

                        {/* Representative Interest */}
                        <Grid item xs={12} sm={6} md={6} className={`align-content-center`}>
                            <label htmlFor="client-interest" className='font15px'>Does your representative have a direct or indirect interest in the account other than an interest in commissions or fees?</label>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6}>
                            <FormControl component="fieldset" error={Boolean(errors.client_interest)}>
                                <Controller
                                    name="client_interest"
                                    control={control}
                                    defaultValue={2}
                                    rules={{ required: "Please select an option" }}
                                    render={({ field }) => (
                                        <RadioGroup row id="client-interest" {...field} value={field.value || ''}>
                                            {radioOptionArray.map((option) => (
                                                <FormControlLabel
                                                    key={option.value}
                                                    value={option.value}
                                                    control={<Radio sx={radioColorSx} />}
                                                    label={option.label}
                                                />
                                            ))}
                                        </RadioGroup>
                                    )}
                                />
                                {errors.client_interest && (
                                    <FormHelperText>{errors.client_interest.message}</FormHelperText>
                                )}
                            </FormControl>
                        </Grid>

                        {/* Account Operated by Third Party */}
                        <Grid item xs={12} sm={6} md={6} className={`align-content-center`}>
                            <label htmlFor="client-account_operated_by_third_party" className='font15px'>Is the account operated by a third party?</label>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6}>
                            <FormControl component="fieldset" error={Boolean(errors.client_account_operated_by_third_party)}>
                                <Controller
                                    name="client_account_operated_by_third_party"
                                    control={control}
                                    defaultValue={2}
                                    rules={{ required: "Please select an option" }}
                                    render={({ field }) => (
                                        <RadioGroup row id="client-account_operated_by_third_party" {...field} value={field.value || ''}>
                                            {radioOptionArray.map((option) => (
                                                <FormControlLabel
                                                    key={option.value}
                                                    value={option.value}
                                                    control={<Radio sx={radioColorSx} />}
                                                    label={option.label}
                                                />
                                            ))}
                                        </RadioGroup>
                                    )}
                                />
                                {errors.client_account_operated_by_third_party && (
                                    <FormHelperText>{errors.client_account_operated_by_third_party.message}</FormHelperText>
                                )}
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={12} md={12}></Grid>
                    </Grid>

                    {/* ==================TAX PAYER RESIDENCY ================ */}

                    <Grid item xs={12}>
                        <Typography variant='h3' className='form-head-gray-title'>TAX PAYER RESIDENCY</Typography>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-left'}`}>
                        <label htmlFor="is-tex-resident-canada" className='font15px'>Is {personName} {' '} {personLname} a tax resident of canada?</label>
                    </Grid>

                    <Grid item xs={12} sm={6} md={2}>
                        <FormControl component="fieldset" error={Boolean(errors.is_tax_resident_canada)}>
                            <Controller
                                name="is_tax_resident_canada"
                                control={control}
                                defaultValue={2}
                                rules={{ required: "Please select an option" }}
                                render={({ field }) => (
                                    <RadioGroup
                                        row
                                        aria-labelledby="is_tax_resident_canada"
                                        {...field}
                                        value={field.value || ''}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            field.onChange(value); // RHF's handler

                                            if (value == 1) {
                                                setValue("is_tax_resident_other", "2");
                                                setValue("is_tax_resident_usa", "2");
                                            }
                                        }}
                                    >
                                        {radioOptionArray.map((option) => (
                                            <FormControlLabel
                                                key={option.value}
                                                value={option.value}
                                                control={<Radio sx={radioColorSx} />}
                                                label={option.label}
                                            />
                                        ))}
                                    </RadioGroup>
                                )}
                            />
                            {errors.is_tax_resident_canada && (
                                <FormHelperText>{errors.is_tax_resident_canada.message}</FormHelperText>
                            )}
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}></Grid>

                    <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-left'}`}>
                        <label htmlFor="is-tex-resident-usa" className='font15px pr-10px'>Is {personName} {' '} {personLname}  a tax resident of the united states?</label>
                    </Grid>

                    <Grid item xs={12} sm={6} md={2}>
                        <FormControl component="fieldset" error={Boolean(errors.is_tax_resident_usa)}>
                            <Controller
                                name="is_tax_resident_usa"
                                control={control}
                                defaultValue={2}
                                rules={{ required: "Please select an option" }}
                                render={({ field }) => (
                                    <RadioGroup row aria-labelledby="is_tax_resident_usa" {...field} value={field.value || ''}>
                                        {radioOptionArray.map((option) => (
                                            <FormControlLabel
                                                key={option.value}
                                                value={option.value}
                                                control={
                                                    <Radio
                                                        sx={radioColorSx}
                                                        disabled={isTaxResidentCanada == 1}
                                                    />
                                                }
                                                label={option.label}
                                            />
                                        ))}
                                    </RadioGroup>
                                )}
                            />
                            {errors.is_tax_resident_usa && (
                                <FormHelperText>{errors.is_tax_resident_usa.message}</FormHelperText>
                            )}
                        </FormControl>


                    </Grid>
                    <Grid item xs={12} sm={12} md={6}></Grid>

                    <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-left'}`}>
                        <label htmlFor="is-tex-resident-other" className='font15px pr-10px'>Is {personName} {' '} {personLname}  a tax resident of a jurisdiction other then canada or the united states?</label>
                    </Grid>

                    <Grid item xs={12} sm={6} md={2}>

                        <FormControl component="fieldset" error={Boolean(errors.is_tax_resident_other)}>
                            <Controller
                                name="is_tax_resident_other"
                                control={control}
                                defaultValue={2}
                                rules={{ required: "Please select an option" }}
                                render={({ field }) => (
                                    <RadioGroup
                                        row
                                        aria-labelledby="is-tax-resident-other"
                                        {...field}
                                        value={field.value || ''}
                                    >
                                        {radioOptionArray.map((option) => (
                                            <FormControlLabel
                                                key={option.value}
                                                value={option.value}
                                                control={
                                                    <Radio
                                                        sx={radioColorSx}
                                                        disabled={isTaxResidentCanada == 1 || isTaxResidentUsa == 1}
                                                    />
                                                }
                                                label={option.label}
                                            />
                                        ))}
                                    </RadioGroup>
                                )}
                            />
                            {errors.is_tax_resident_other && (
                                <FormHelperText>{errors.is_tax_resident_other.message}</FormHelperText>
                            )}
                        </FormControl>

                    </Grid>
                    <Grid item xs={12} sm={12} md={6}></Grid>

                    {isTaxResidentOther == 1 ?
                        <>
                            <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-left'}`}>
                                <label htmlFor="is-tex-resident-canada" className='font15px pr-10px'>Social Insurance Number</label>
                            </Grid>

                            <Grid item xs={12} sm={6} md={2}>
                                <Controller
                                    name="sin"
                                    control={control}
                                    // defaultValue={p_sin}
                                    // rules={{
                                    //     required: "Social Insurance Number is required",
                                    //     pattern: {
                                    //         value: /^[0-9]{9}$/, // Ensures exactly 9 digits
                                    //         message: "SIN must be 9 digits"
                                    //     }
                                    // }}
                                    render={({ field }) => (
                                        <TextField
                                            {...field}
                                            label="Social Insurance Number"
                                            fullWidth
                                            size="small"
                                            margin="dense"
                                            // inputProps={{ inputMode: "numeric", pattern: "[0-9]*", maxLength: 9 }}
                                            error={Boolean(errors.sin)}
                                            helperText={errors.sin?.message}
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={6}></Grid>
                        </>
                        : null}



                    <Grid item xs={12}>
                        <Typography component={'h5'} className='form-head-gray-title'>W-8 Ben Special Rates and Conditions</Typography>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-left'}`}>
                        <label htmlFor="is-tex-resident-canada" className='font15px pr-10px'>Is {personName} {' '} {personLname}  wish to make claim for  tax treaty benefits?</label>
                    </Grid>

                    <Grid item xs={12} sm={6} md={2}>
                        <FormControl component="fieldset" error={Boolean(errors.is_tax_benefit)}>
                            <Controller
                                name="is_tax_benefit"
                                control={control}
                                defaultValue={2}
                                rules={{ required: "Please select an option" }}
                                render={({ field }) => (
                                    <RadioGroup row aria-labelledby="is_tax_benefit" {...field} value={field.value || ''}>
                                        {radioOptionArray.map((option) => (
                                            <FormControlLabel
                                                key={option.value}
                                                value={option.value}
                                                control={<Radio sx={radioColorSx} />}
                                                label={option.label}
                                            />
                                        ))}
                                    </RadioGroup>
                                )}
                            />
                            {errors.is_tax_benefit && (
                                <FormHelperText>{errors.is_tax_benefit.message}</FormHelperText>
                            )}
                        </FormControl>

                    </Grid>
                    <Grid item xs={12} sm={12} md={6}></Grid>
                </Grid>


                <Grid item xs={12} sm={6} className='text-center'>
                    <Button variant='contained' className='m-3 raintree-btn-green' onClick={handleRoleBack}>
                        Back
                    </Button>
                    <Button variant='contained' className='m-3 raintree-btn-green' type='submit'>
                        Next
                    </Button>
                </Grid>
            </form >
            <OpenTcpDialogComponent />
            <OpenPepHioDialogComponent />
            <InsiderDialogComponent />
            {loader}
            < ToastContainer />
        </>
    )
}

export default RegulatoryInformation;